// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29Ds9","placeholdersHeader":"styles_placeholdersHeader__2Qf_i","editorStyle":"styles_editorStyle__Y5SrY","placeholdersBox":"styles_placeholdersBox__1VZs7"};